import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { Store } from "../../Store";
import "./SideNavBar.css";
import { RiDashboard2Fill } from "react-icons/ri";
import { MdCategory } from "react-icons/md";
import { HiOutlineDocumentText } from "react-icons/hi";
import { FaRegFolderOpen, FaSignOutAlt, FaTags, FaDownload, FaPencilAlt, FaDatabase } from "react-icons/fa";
import { MdOutlineContactMail } from "react-icons/md";

const linkList = [
  { icon: <RiDashboard2Fill className="icon-md" />, text: "Dashboard", url: "/admin/dashboard" },
  { icon: <MdCategory className="icon-md" />, text: "Manage Industries", url: "/admin/industries" },
  { icon: <FaDatabase className="icon-md" />, text: "Report Registry", url: "/admin/reports/registry" },
  { icon: <HiOutlineDocumentText className="icon-md" />, text: "Generate Report (AI)", url: "/admin/reports/generate" },
  { icon: <FaPencilAlt className="icon-md" />, text: "Create Manual Report", url: "/admin/reports/create-manual" },
  { icon: <FaRegFolderOpen className="icon-md" />, text: "My Reports", url: "/admin/reports/archive" },
  { icon: <FaTags className="icon-md" />, text: "Plans", url: "/admin/plans" },
  { icon: <FaDownload className="icon-md" />, text: "Sample Requests", url: "/admin/sample-requests" },
  { icon: <MdOutlineContactMail className="icon-md" />, text: "Contact Requests", url: "/admin/contact-requests" }
];

const active_text = {
  Dashboard: "dashboard",
  "Manage Industries": "industries",
  "Report Registry": "reports/registry",
  "Generate Report (AI)": "reports/generate",
  "Create Manual Report": "reports/create-manual",
  "My Reports": "reports/archive",
  "Plans": "plans",
  "Sample Requests": "sample-requests",
  "Contact Requests": "contact-requests"
};

export default function SideNavbar({ isExpanded }) {
  const pathname = window.location.pathname;
  const [activeLink, setActiveLink] = useState("Dashboard");
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { userInfo } = state;
  const navigate = useNavigate();

  const signoutHandler = () => {
    ctxDispatch({ type: "USER_SIGNOUT" });
    localStorage.removeItem("userInfo");
    localStorage.removeItem("token");
    localStorage.removeItem("permissions");
    navigate("/");
  };

  const activeLinkHandler = (text) => pathname.includes(active_text[text]);

  return (
    <>
      {userInfo ? (
        <div
          className={
            isExpanded
              ? "side-nav-container"
              : "side-nav-container side-nav-container-NX"
          }
        >
          <div className="brand-link">
            <div className="brand-logo">EX</div>
            <span className="brand-text ms-2 font-weight-light">ElementalX Admin</span>
          </div>

          <div className="sidebar">
            <div className="user-panel mt-3 pb-3 mb-3 d-flex">
              <div className="info">
                <span className="d-block info-text">
                  Welcome {userInfo.name || userInfo.email}
                </span>
              </div>
            </div>
            <nav className="mt-2">
              <ul
                className="nav-pills nav-sidebar px-0 d-flex flex-column flex-wrap"
                data-widget="treeview"
                role="menu"
                data-accordion="false"
              >
                {linkList.map(({ icon, text, url }) => (
                  <li
                    key={url}
                    className={`nav-item has-treeview ${
                      isExpanded ? "menu-item" : "menu-item menu-item-NX"
                    } ${activeLinkHandler(text) && "active-item"}`}
                    onClick={() => setActiveLink(text)}
                  >
                    <Link to={url} className="nav-link">
                      {icon}
                      <p className="ms-2">{text}</p>
                    </Link>
                  </li>
                ))}
                <li
                  className={`nav-item has-treeview ${
                    isExpanded ? "menu-item" : "menu-item menu-item-NX"
                  }`}
                >
                  <Link onClick={signoutHandler} to="/" className="nav-link">
                    <FaSignOutAlt className="icon-md" />
                    <p className="ms-2">Log Out</p>
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      ) : null}
    </>
  );
}
